import request from 'crm/utils/request'
import api from './api'

// 获取-入群配置信息设置
export async function getJoinGroupWay() {
    return request(api.getJoinGroupWay.url)
}

// 设置-入群配置信息设置
export async function setJoinGroupWay(payload) {
    return request(api.setJoinGroupWay.url, {
        method: api.setJoinGroupWay.type,
        body: payload.body,
    })
}
